export const getNrOfColumns = (htmlRef, customCssProperty = '--columns') => {
  return parseInt(getComputedStyle(htmlRef).getPropertyValue(customCssProperty));
};

const getNrOfRows = (array, nrOfColumns) => Math.ceil(array.length / nrOfColumns);

export const makeMasonryMatrix = (array, htmlRef, customCssProperty) => {
  const nrOfColumns = getNrOfColumns(htmlRef, customCssProperty);
  const nrOfRows = getNrOfRows(array, nrOfColumns);
  const matrix = [];
  for (let col = 0; col < nrOfColumns; col++) {
    const column = [];
    for (let row = col; row <= nrOfRows * nrOfColumns; row = row + nrOfColumns) {
      array[row] !== undefined && column.push(array[row]);
    }
    matrix.push(column);
  }
  return matrix;
};
